export default __webpack_public_path__ + "static/investment-hero-background-finished-db32066aca356d0421d7dbdba1891ff6.jpg";